import classNames from "classnames";
import Link from "next/link";
import { paths } from "@libs/paths";
import { IFImg } from "@libs/utils/IFImg";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  customStyle: string;
};

export const AppLinkSection: FC<Props> = ({ customStyle }) => {
  return (
    <section className={classNames(styles.appLinkSection, customStyle)}>
      <div className={styles.appLinkContainer}>
        <div className={styles.appLinkBox}>
          <div className={styles.appLinkDetail}>
            <h2 className={styles.appLinkTitle}>
              <img
                src={IFImg("/img/logo_fansta.svg")}
                height="32"
                alt="Fansta"
                className={styles.appLinkTitleImage}
              />
            </h2>
            <p className={styles.appLinkText}>
              スポーツライブビューイングを楽しめる
              <br />
              スポーツバーを多数掲載中！
              <br />
              スポーツバー探し・予約ならFanstaで。
            </p>
            <ul className={styles.appLinkApp}>
              <li>
                <Link href={paths.appStore} target="_blank">
                  <img
                    src={IFImg("/img/campaign/common/appstore.svg")}
                    width={159}
                    height={46}
                    alt=""
                  />
                </Link>
              </li>
              <li>
                <Link href={paths.googlePlay} target="_blank">
                  <img
                    src={IFImg("/img/campaign/common/googleplay.svg")}
                    width={159}
                    height={46}
                    alt=""
                  />
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.appLinkImage}>
            <img
              src={IFImg("/img/campaign/common/fansta-mock.png")}
              width={849}
              height={923}
              alt=""
            />
          </div>
        </div>
        <div>
          <Link href={paths.home} className={styles.appLinkTopButton}>
            <span>Fanstaトップページ</span>
          </Link>
        </div>
      </div>
    </section>
  );
};
